<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-12-22 11:50:17
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-09-20 15:10:48
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\OrderManagement\prescriptionDetial.vue
-->
<template>
  <div class="content">
    <el-dialog
        title="电子处方详情"
        v-if='detialDrawer'
        :visible.sync="detialDrawer"
        width="60%"
        center>
        <div class="content-box">
             <div class="left-item" :style="{width:showImg ? '55%' : '100%'}">
                <el-scrollbar style="height: 100%;">
                    <div class="item-info">
                        <div class="item-text">
                            <div class="left-title">订单编号：</div>
                            <div class="right-content">{{ orderDetails.no }}</div>
                        </div>
                        <div class="item-text">
                            <div class="left-title">处方类型：</div>
                            <div class="right-content">{{ orderDetails.type | prescription }}</div>
                        </div>
                        <div class="item-text">
                            <div class="left-title">就诊人：</div>
                            <div class="right-content">{{ orderDetails.patientName }}</div>
                        </div>
                        <div class="item-text">
                            <div class="left-title">性别：</div>
                            <div class="right-content">{{ orderDetails.patientGender == 1 ? '男' : '女' }}</div>
                        </div>
                        <div class="item-text">
                            <div class="left-title">年龄：</div>
                            <div class="right-content">{{ orderDetails.patientAge }}岁</div>
                        </div>
                        <div class="item-text" v-if="userPlatForm != 'organization'">
                            <div class="left-title">线下机构：</div>
                            <div class="right-content">{{ orderDetails.hospitalName }}</div>
                        </div>
                        <div class="item-text">
                            <div class="left-title">互医机构：</div>
                            <div class="right-content">{{ orderDetails.platformName }}</div>
                        </div>
                        <div class="item-text">
                            <div class="left-title">创建时间：</div>
                            <div class="right-content">{{ orderDetails.prescriptionTime }}</div>
                        </div>
                        <div class="item-text">
                            <div class="left-title">问诊类型：</div>
                            <div class="right-content">{{ orderDetails.serviceSourceCode == 1 ? '全病程' : '互联网医院' }}</div>
                        </div>
                        <div class="item-text">
                            <div class="left-title">服务名称：</div>
                            <div class="right-content">{{ orderDetails.serviceCode | serviceCodeFilter }}</div>
                        </div>
                        <div class="item-text">
                            <div class="left-title">处方医生：</div>
                            <div class="right-content">{{ orderDetails.prescriberName }}</div>
                        </div>
                        <div class="item-text">
                            <div class="left-title">职称：</div>
                            <div class="right-content">{{ orderDetails.prescriberTitleName }}</div>
                        </div>
                        <div class="item-text">
                            <div class="left-title">初步诊断：</div>
                            <div class="right-content">{{ orderDetails.initDiagnosis }}</div>
                        </div>
                        <div class="item-text">
                            <div class="left-title">订单付款人：</div>
                            <div class="right-content">==========</div>
                        </div>
                    </div>
                    <div class="info-table">
                        <div class="table-left">处方信息：</div>
                        <div class="table-right">
                            <BaseTable 
                            size="mini" 
                            :data="orderDetails.itemList" 
                            :column="prescriptionConfig"
                            :auto-scroll="true"
                            style="max-width:100%"
                            > 
                            </BaseTable>
                        </div>
                    </div>
                    <div class="view-pic">
                        <div class="pic-left">处方查看：</div>
                        <div class="pic-right">
                            <el-button style="padding:8px 31px" type="primary" size="mini" @click="viewImg">查看大图</el-button>
                        </div>
                    </div>
                </el-scrollbar>
             </div>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import local from "@/utils/local.js";
import prescriptionConfig from './common/prescriptionConfig'
import { prescriptionDetails} from './api/orderPay'
import { imgBaseURL } from '@/utils/common'
export default {
  mixins: [prescriptionConfig],
  data() {
    return {
        detialDrawer:false,
        orderDetails:{},
        imgBaseURL:imgBaseURL,
        userPlatForm:local.get('userPlatForm'),//平台：platForm 机构：organization  local.get('userPlatForm')
        orgName: local.get('orgName') ? local.get('orgName') : '',
    }
  },
  methods: {
    /**
     * @description: 处方详情数据
     * @param {*}
     * @return {*}
     */
    detial(e) {
        this.showImg = false
        this.detialDrawer = true
        prescriptionDetails(e.row.id)
            .then((res) => {
            if (res.code == 0) {
                this.orderDetails = res.data
                this.detialDrawer = true
            }
            })
            .catch((error) => {
                this.$message.error(`${error.message}`)
            })
    },
     /**
     * @description: 查看大图
     * @param {*}
     * @return {*}
     */
    viewImg(){
        window.open(process.env.VUE_APP_OSS_URL + this.orderDetails.pdf)
    },
    
  },
  filters: {
    prescription(value) {
      switch (value * 1) {
        case 1:
          return '西药处方'
        case 2:
          return '中药处方'
        case 3:
          return '营养处方'
        case 4:
          return '运动处方'
        case 5:
          return '治疗处方'
      }
    },
    serviceCodeFilter(value) {
      switch (value * 1) {
        case 1:
          return '在线问诊'
        case 2:
          return '在线续方'
        case 3:
          return '在线随访'
        case 4:
          return '在线复诊'
      }
    },
  },
}
</script>

<style lang="less" scoped>
    .content-box{
        height: 80vh;
        width: 100%;
        display: flex;
        justify-content: space-between;
        .left-item{
            width: 55%;
            height: 100%;
            // padding: 26px;
            padding-top: 0px;
            .item-info{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .item-text{
                    width: 50%;
                    display: flex;
                    justify-content: space-between;
                    padding: 10px;
                    margin-bottom: 10px;
                    .left-title{
                        width: 90px;
                        margin-right: 20px;
                    }
                    .right-content{
                        flex: 1;
                    }
                }
            }
            .info-table{
                display: flex;
                margin-bottom: 10px;
                .table-left{
                    width: 90px;
                    margin-right: 20px;
                    padding: 10px;
                }
                .table-right{
                    flex: 1;
                    width: 100%;
                }
            }
            .view-pic{
                display: flex;
                align-items: center;
                .pic-left{
                    width: 90px;
                    margin-right: 20px;
                    padding: 10px;
                }
                .pic-right{
                    margin-right: 20px;
                    padding: 10px;
                }
            }
        }
        .right-item{
            width: 45%;
            height: 100%;
            padding: 26px;
            padding-top: 0px;
        }
    }
    /deep/.el-scrollbar__wrap {
        overflow-x: hidden
    }
    /deep/.el-table--mini td, .el-table--mini th{
        padding: 10px 0;
    }
</style>
